import { useState } from 'react';

const categories = [
  {
    id: 'cilt',
    label: 'Cilt Problemi',
    icon: 'ri-emotion-happy-line',
    desc: 'Leke, kırışıklık, cilt tonu',
    treatments: [
      { name: 'ARC Cilt Yenileme', desc: 'Cerrahi olmadan cilt gençleştirme teknolojisi', icon: 'ri-sparkling-2-line' },
      { name: 'Cilt Bakımı', desc: 'Derin temizlik ve nem dengesi', icon: 'ri-leaf-line' },
      { name: 'İğnesiz Mezoterapi', desc: 'Vitamin ve hyaluronik asit enjeksiyonu', icon: 'ri-drop-line' },
    ],
  },
  {
    id: 'tuy',
    label: 'Tüy Problemi',
    icon: 'ri-flashlight-line',
    desc: 'İstenmeyen kıllar, hassas bölgeler',
    treatments: [
      { name: 'Lazer Epilasyon', desc: 'Kalıcı tüy azaltma çözümü', icon: 'ri-flashlight-line' },
      { name: 'İğneli Epilasyon', desc: 'Hassas bölgelerde kalıcı yok etme', icon: 'ri-focus-3-line' },
      { name: 'Buz Epilasyon', desc: 'Soğutmalı konforlu epilasyon', icon: 'ri-temp-cold-line' },
    ],
  },
  {
    id: 'vucut',
    label: 'Vücut Şekillendirme',
    icon: 'ri-body-scan-line',
    desc: 'İncelme, sıkılaşma, yağ azaltma',
    treatments: [
      { name: 'EMS Slim', desc: '20.000 kas aktivasyonu ile şekillendirme', icon: 'ri-body-scan-line' },
      { name: 'G5 Bölgesel İncelme', desc: 'Bölgesel yağ kırma masajı', icon: 'ri-bar-chart-grouped-line' },
      { name: 'Ameliyatsız Yüz Germe', desc: 'HIFU teknolojisi ile yüz germe', icon: 'ri-vip-diamond-line' },
    ],
  },
  {
    id: 'makyaj',
    label: 'Kalıcı Makyaj',
    icon: 'ri-paint-brush-line',
    desc: 'Kaş, dudak, eyeliner',
    treatments: [
      { name: 'PhiBrows Kaş', desc: 'Mikroblading ile doğal kaş tasarımı', icon: 'ri-paint-brush-line' },
      { name: 'Kalıcı Dudak', desc: 'Doğal ton ve dolgunluk efekti', icon: 'ri-artboard-line' },
      { name: 'Kalıcı Eyeliner', desc: 'Gözleri belirginleştiren kalıcı çizgi', icon: 'ri-eye-line' },
    ],
  },
];

export default function SmartServiceSelector() {
  const [selected, setSelected] = useState<string | null>(null);

  const selectedCat = categories.find((c) => c.id === selected);

  const whatsappUrl = (name: string) =>
    `https://wa.me/905412190629?text=${encodeURIComponent(`Merhaba, ${name} hakkında bilgi almak istiyorum.`)}`;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">Kişisel Analiz</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            Size En Uygun
            <br />
            <em className="text-[#D4AF37]">İşlemi Bulalım</em>
          </h2>
          <p className="text-[#6B6B6B] text-sm max-w-md mx-auto">
            İhtiyacınızı seçin, size özel tedavi önerilerini anında görün
          </p>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setSelected(selected === cat.id ? null : cat.id)}
              className={`p-5 rounded-2xl border-2 text-left transition-all duration-300 cursor-pointer group ${
                selected === cat.id
                  ? 'border-[#D4AF37] bg-gradient-to-br from-[#FFF8F0] to-[#FFE5EC] shadow-md scale-105'
                  : 'border-[#FFE5EC] bg-white hover:border-[#D4AF37]/50 hover:bg-[#FFF8F0]'
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-3 transition-all duration-300 ${
                selected === cat.id
                  ? 'bg-gradient-to-br from-[#D4AF37] to-[#FFB3C6]'
                  : 'bg-[#FFE5EC] group-hover:bg-gradient-to-br group-hover:from-[#D4AF37]/30 group-hover:to-[#FFB3C6]/30'
              }`}>
                <i className={`${cat.icon} text-xl ${selected === cat.id ? 'text-white' : 'text-[#D4AF37]'}`}></i>
              </div>
              <h3 className={`font-semibold text-sm mb-1 transition-colors ${selected === cat.id ? 'text-[#2D2D2D]' : 'text-[#2D2D2D]'}`}>
                {cat.label}
              </h3>
              <p className="text-[#6B6B6B] text-xs leading-relaxed">{cat.desc}</p>
              {selected === cat.id && (
                <div className="mt-2 flex items-center gap-1 text-[#D4AF37] text-xs font-medium">
                  <i className="ri-check-line"></i>
                  Seçildi
                </div>
              )}
            </button>
          ))}
        </div>

        {/* Recommendations */}
        {selectedCat && (
          <div className="animate-fade-in">
            <div className="bg-gradient-to-br from-[#FFF8F0] to-[#FFE5EC] rounded-2xl p-6 md:p-8 border border-[#D4AF37]/20">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#D4AF37]">
                  <i className="ri-magic-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="font-serif text-lg text-[#2D2D2D] font-bold">
                    {selectedCat.label} için Önerilerimiz
                  </h3>
                  <p className="text-[#6B6B6B] text-xs">Size özel en uygun tedaviler</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {selectedCat.treatments.map((treatment, idx) => (
                  <div
                    key={idx}
                    className="bg-white rounded-xl p-5 border border-[#FFE5EC] hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-gradient-to-br from-[#D4AF37]/20 to-[#FFB3C6]/20 mb-3">
                      <i className={`${treatment.icon} text-[#D4AF37] text-lg`}></i>
                    </div>
                    <h4 className="font-semibold text-[#2D2D2D] text-sm mb-1">{treatment.name}</h4>
                    <p className="text-[#6B6B6B] text-xs mb-4 leading-relaxed">{treatment.desc}</p>
                    <a
                      href={whatsappUrl(treatment.name)}
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="inline-flex items-center gap-1.5 bg-[#25D366] text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-[#1DA851] transition-colors whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line"></i>
                      Bilgi Al &amp; Randevu
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {!selected && (
          <div className="text-center">
            <div className="inline-flex items-center gap-2 text-[#6B6B6B] text-sm">
              <i className="ri-arrow-up-line text-[#D4AF37]"></i>
              Yukarıdan bir kategori seçin
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
